import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent{

  constructor(
    //private translate: TranslateService,
  ) { 
    // debugger;
    // translate.setDefaultLang('es');
  }
  
  // setLanguage(lang) {
  //   this.translate.use(lang);
  // }

}
